import { IPartnerFinSobRow } from '../../model'

/** `finYoyGrowth`/`sobYoyGrowth` are a market-wide YoY growth rate the backend repeats
 *  identically across a category's rows (including across partners) rather than a per-row
 *  measure to sum or weight — the first non-null value found is the value. */
export const findGrowthValue = (
  rows: IPartnerFinSobRow[],
  field: 'finYoyGrowth' | 'sobYoyGrowth'
): number | null => rows.find((row) => row[field] !== null)?.[field] ?? null
